import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const KOREA_REVENUE_SUCCESS = 'KOREA_REVENUE_SUCCESS';
export const KOREA_REVENUE_LOADING = 'KOREA_REVENUE_LOADING';

const { revenueForKorea: { getRevenueForKorea } } = apiUrls;


export const getKoreaRevenueDetails = () => async (dispatch) => {
  try {
    const { url } = getRevenueForKorea
    // const requestData = {
    //     ...getRevenueForKorea,
    //     // url: url.replace('{{year}}', year)
        
    // };
    const data = await REQUEST(getRevenueForKorea);
    dispatch({
      type: KOREA_REVENUE_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: KOREA_REVENUE_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: KOREA_REVENUE_LOADING,
    isLoading
  })
}
